export interface IPagination {
  currentPage: number;
  lastPage: number;
  perPage: number;
  total: number;
}

export abstract class ApiResponse<Data> {
  public _apiResponse = true;

  protected data?: Data | null;
  protected pagination?: IPagination;

  public abstract isPaginated(): boolean;

  public constructor(data?: Data | null, pagination?: IPagination) {
    this.data = data;
    this.pagination = pagination;
  }

  public getData(): Data | null | undefined {
    return this.data;
  }

  public getPagination(): IPagination | undefined {
    return this.pagination;
  }

  public hasData(): boolean {
    return typeof this.data !== 'undefined';
  }

  public isDataNull(): boolean {
    return this.data === null;
  }

  public hasPagination(): boolean {
    return typeof this.pagination !== 'undefined';
  }
}

export class SimpleResponse<Data> extends ApiResponse<Data> {
  public isPaginated(): boolean {
    return false;
  }
}

export class PaginatedResponse<Data> extends ApiResponse<Data> {
  public isPaginated(): boolean {
    return true;
  }
}
